<template>
  <div>
    <a-card>
      <span slot="title" class="title">{{ `${typepage.toUpperCase()} List` }}</span>
      <div slot="extra">
        <a-input-search
          placeholder="input search text"
          style="width: 300px"
          v-model="search"
        />
      </div>
      <a-tabs :activeKey="activetab" @change="handleTab">
        <a-tab-pane v-if="!onlyViews" style="margin:auto" key="process">
          <template slot="tab">
            <span>Need Process</span>
            <a-badge
              key="badge"
              class="m-badge m-badge-small"
              :count="list_process.length"
              :numberStyle="{ backgroundColor: 'red' }"
              v-if="list_process.length > 0"
            >
            </a-badge>
          </template>
          <div class="loading" v-if="loading.process">
            <a-spin :spinning="loading.process" tip="Loading..."></a-spin>
          </div>
          <a-table
            v-else
            :columns="column_process"
            :dataSource="process_list"
            id="id_pfi"
            size="small"
            :pagination="pagination"
            bordered
            :scroll="{ x: 100 }"
          >
            <a
              slot="no"
              slot-scope="item"
              @click="handleLink(item.jenis, item.id)"
              >{{ item.no }}</a
            >
            <span slot="value" slot-scope="amount">
              <CurrencyJustified
                v-if="amount.value"
                :key="amount.key"
                :currencyValue="amount.currency"
                :valueNumber="amount.value"
              />
              <div v-else style="text-align:center;width:100%">-</div>
            </span>
            <span slot="balance" slot-scope="amount">
              <CurrencyJustified
                v-if="amount.sisa"
                :key="amount.key"
                :currencyValue="amount.currency"
                :valueNumber="amount.sisa"
              />
              <div v-else style="text-align:center;width:100%">-</div>
            </span>
            <span slot="update_by" slot-scope="item">
              <span v-if="item.tlc_updated">
                {{ item.tlc_updated }} /
                {{
                  item.date_updated
                    ? moment(item.date_updated, getDateTimeStandartFormat).format(
                        getDefaultDateFormat
                      )
                    : "-"
                }}
              </span>
              <span v-else>
                -
              </span>
            </span>
            <span slot="centang" slot-scope="item">
              <!-- <a-popconfirm
                :key="item.key"
                title="Are you sure to change ?"
                @confirm="changeActionItem(item)"
                ok-text="Yes"
                cancel-text="No"
              > -->
                <a-button :key="item.key" type="primary" @click="handlemodal(item)"
                :disabled="item.proses=='disabled'"
                >
                  Process
                </a-button>
              <!-- </a-popconfirm> -->
            </span>
          </a-table>
        </a-tab-pane>
        <a-tab-pane tab="PI Release" key="release">
          <div class="loading" v-if="loading.release">
            <a-spin :spinning="loading.release" tip="Loading..."></a-spin>
          </div>
          <a-table
            v-else
            :columns="column_release"
            :dataSource="release_list"
            id="id_ep1"
            size="small"
            :pagination="pagination"
            bordered
            :scroll="{ x: 100 }"
          >
            <a
              slot="no"
              slot-scope="item"
              @click="handleLink(item.jenis, item.id)"
              >{{ item.no }}</a
            >
            <span
              slot="no_trans"
              slot-scope="item"
              >{{ item.no_trans }}</span
            >
            <span slot="value" slot-scope="amount">
              <CurrencyJustified
                v-if="amount.value"
                :key="amount.key"
                :currencyValue="amount.currency"
                :valueNumber="amount.value"
              />
              <div v-else style="text-align:center;width:100%">-</div>
            </span>
            <span slot="remaining_release" slot-scope="item">
                <CurrencyJustified
                  v-if="item.remaining_balance"
                  :key="item.key"
                  :currencyValue="item.currency"
                  :valueNumber="item.remaining_balance"
                />
                <div v-else style="text-align:center;width:100%">-</div>
              </span>
            <span slot="update_by" slot-scope="item">
              <span v-if="item.tlc_updated">
                {{ item.tlc_updated }} /
                {{
                  item.date_updated
                    ? moment(item.date_updated, getDateTimeStandartFormat).format(
                        getDefaultDateFormat
                      )
                    : "-"
                }}
              </span>
              <span v-else>
                -
              </span>
            </span>
            <span slot="no_bkk" slot-scope="item">
              <a v-if="item.bkk_id"
              @click="handleLink('bkk', item.bkk_id)"
              >{{ item.no_bkk }}</a
              >
              <span v-else>-</span>
            </span>
            <span slot="status" slot-scope="item">
              <Status :status="item.status" />
            </span>
            <span slot="action" slot-scope="item">
              <a-button v-if="item.id_rilis" type="primary" @click="handleManifest(item)">
                Manifest
              </a-button>
              <a-button v-else type="default" @click="handleLink(item.jenis, item.id)">
                Manifest
              </a-button>
            </span>
          </a-table>
        </a-tab-pane>
      </a-tabs>
    </a-card>
    <a-modal
      v-model="processModal"
      :maskClosable="false"
      width="70%"
      @cancel="handleCloseModal"
    >
      <span slot="title">
        Process PI Release
      </span>
      <a-form-model ref="modalForm" :model="modalFormInput" :rules="rulesForm">
        <a-row :gutter="14">
          <a-col :xs="{ span: 24 }" :lg="{ span: 10 }">
            <div class="container-essential">
              <h4>{{modalForm.no}}</h4>
              <h4>{{modalForm.description}}</h4>
              <span><b>{{formatCurrency(modalForm.currency,remainingBalance)}}</b> <i> (Remaining Balance)</i></span>
            </div>
            <div class="container-dash margin-top">
              <a-form-model-item label="Item"
              :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }"
              prop="item" ref="item">
                <a-input
                  class="m-width-full"
                  autocomplete="off"
                  v-model="modalFormInput.item"
                ></a-input>
              </a-form-model-item>
              <a-form-model-item
              label="Type"
              :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }"
              prop="type" ref="type">
                <a-radio-group buttonStyle="solid" v-model="modalFormInput.type" @change="handleChangeType" :disabled="modalForm.mode=='edit'">
                  <a-radio-button value="1" :disabled="isOnlyNonItem">Non Tax</a-radio-button>
                  <a-radio-button value="2">Tax</a-radio-button>
                </a-radio-group>
              </a-form-model-item>
              <a-form-model-item label="Value"
              :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }"
              prop="val" ref="val">
                <a-input-number
                  :min="0"
                  class="m-width-full m-text-align right"
                  @keydown="onlyNumber"
                  :formatter="
                    (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
                  "
                  :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
                  v-model="modalFormInput.val"
                ></a-input-number>
              </a-form-model-item>
              <a-form-model-item 
              v-if="modalFormInput.type=='2'"
              :disabled="modalForm.mode=='edit'"
              label="Type Tax"
              :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }"
              prop="type_tax" ref="type_tax">
                <a-select
                  v-model="modalFormInput.type_tax"
                  showSearch
                  option-filter-prop="children"
                  :filter-option="filterOption"
                >
                  <a-select-option
                    v-for="item in getType_tax"
                    :key="item.value"
                    :value="item.value"
                  >
                    {{ item.text }}
                  </a-select-option>
                </a-select>
              </a-form-model-item>
              <a-divider style="margin: 12px 0!important"/>
              <div class="divButtonAdd">
                <a-button v-if="modalForm.mode=='create'" @click="handleAdd" type="primary"><a-icon type="plus"/>Add</a-button>
                <a-button v-if="modalForm.mode=='edit'" @click="handleSaveEdit" type="primary"><a-icon type="save"/>Save</a-button>
                <a-button v-if="modalForm.mode=='edit'" @click="handleCancel" type="danger" class="margin-left"><a-icon type="cancel"/>Cancel</a-button>
              </div>
            </div>
          </a-col>
          <a-col :xs="{ span: 24 }" :lg="{ span: 14 }">
            <div class="container-headertable">
                Usage Details
              </div>
            <a-config-provider :locale="getLocalConfigProvider()">
              <a-table
                :columns="column_usageDtl"
                :dataSource="usageDtl_list"
                id="id_ep1"
                size="small"
                :pagination="pagination"
                bordered
                :scroll="{ x: 100 }"
                :rowKey="(record, index) => {
                  return index;
                }"
              >
                <span slot="number" slot-scope="item,record, index">
                  {{ index + 1 }}
                </span>
                <span slot="value" slot-scope="index, item">
                  {{ formatCurrency(modalForm.currency, item.value) }}
                </span>
                <span slot="tax" slot-scope="index, item">
                  {{ item.type=="1" ? 'Non Tax' : 'Tax' }}
                </span>
                <span slot="tax_type" slot-scope="index, item">
                  {{ getlabeltax(item.type_tax) }}
                </span>
                <a-button-group slot="action" slot-scope="item">
                  <a-button @click="handleEdit(item)" :disabled="modalForm.mode=='edit'" icon="edit" type="primary"/>
                  <a-button @click="handleRemove(item)" :disabled="modalForm.mode=='edit'" icon="delete" type="danger" />
                </a-button-group>
                <template slot="footer">
                  <a-row>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 4 }">
                      <h4>Sub Total</h4>
                      <h4>Total Tax</h4>
                    </a-col>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 20 }">
                      <h4>: {{formatCurrency(modalForm.currency,(isOnlyNonItem ? tax+pphValue : subtotal))}}</h4>
                      <h4>: {{formatCurrency(modalForm.currency,(isOnlyNonItem ? 0 : (tax>0 ? tax-pphValue : pphValue)))}}</h4>
                    </a-col>
                  </a-row>
                  <a-divider style="margin: 12px 0!important"/>
                  <a-row>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 4 }">
                      <h4>Grand Total</h4>
                    </a-col>
                    <a-col :xs="{ span: 24 }" :lg="{ span: 20 }">
                      <h4>: {{formatCurrency(modalForm.currency,(isOnlyNonItem ? tax+pphValue : grandtotals-pphValue))}}</h4>
                    </a-col>
                  </a-row>
                </template>
              </a-table>
            </a-config-provider>
          </a-col>
        </a-row>
        <a-form-model-item label="Note" prop="note" ref="note">
          <a-textarea
            placeholder="Write the note here ... "
            :rows="4"
            v-model="modalForm.note"
          />
        </a-form-model-item>
      </a-form-model>
      <template slot="footer">
        <a-button key="back" type="danger" @click="handleCloseModal"> Cancel </a-button>
        <a-button key="submit" type="primary" @click="handleOkModal" :loading="loadingmodalsave">
          Save
        </a-button>
      </template>
    </a-modal>

    <a-modal
      v-model="processModalOld"
      :maskClosable="false"
    >
      <span slot="title">
        Process BKK Release
      </span>
      <a-form-model ref="modalForm" :model="modalForm" :rules="rulesForm">
        <a-form-model-item label="No"
        :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }"
        prop="no" ref="no">
          <a-input
            disabled
            class="m-width-full"
            autocomplete="off"
            v-model="modalForm.no"
          ></a-input>
        </a-form-model-item>
        <a-form-model-item label="Description"
        :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }"
        prop="description" ref="description">
          <a-textarea
            disabled
            class="m-width-full"
            autocomplete="off"
            v-model="modalForm.description"
          ></a-textarea>
        </a-form-model-item>
        <a-form-model-item label="Value"
        :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }"
        prop="val" ref="val">
          <a-input-number
            :min="0"
            class="m-width-full m-text-align right"
            @keydown="onlyNumber"
            :formatter="
              (value) => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
            :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
            v-model="modalForm.val"
          ></a-input-number>
        </a-form-model-item>
        <a-form-model-item label="Note"
        :label-col="{ span: 4 }" :wrapper-col="{ span: 20 }"
        prop="note" ref="note">
          <a-textarea
            class="m-width-full"
            autocomplete="off"
            v-model="modalForm.note"
          ></a-textarea>
        </a-form-model-item>
      </a-form-model>
      <template slot="footer">
        <a-button key="back" @click="handleCloseModal"> Cancel </a-button>
        <a-button key="submit" type="primary" @click="handleOkModal" :loading="loadingmodalsave">
          Save
        </a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import Status from "@/components/Status.vue";
import _ from "lodash";

export default {
  name: "PIRelease",
  mixins: [GlobalMethod,CurrencyFormat],
  components: { Status },
  props: ["idrilisedit",],
  data() {
    let checkPending;
    let checkValue = (rule, value, callback) => {
      clearTimeout(checkPending);
      if (value==null) {
        return callback(new Error("Please input the value"));
      }

      if(this.modalFormInput.type=='2'){ 
        return callback();
      }else{
        if (value<=0) {
          return callback(new Error("Please input the value"));
        }
      }

      const limit = parseFloat(this.modalForm.maxval);
      if (value > limit) {
        callback(new Error(`Value must be less than ${this.modalForm.maxval}`));
      } else {
        callback();
      }
    };
    return {
      activetab: "process",
      typepage: "",
      list_release: [],
      list_process: [],
      loading: {
        release: false,
        process: false,
      },
      pagination: {
        onChange: (page) => {
          console.log(page);
        },
        pageSize: 20,
        size: "small",
      },
      search: "",
      processModal: false,
      processModalOld: false,
      loadingmodalsave: false,
      modalForm : {
        mode: 'create',
        no : null,
        description : null,
        val : null,
        note: null,
      },
      modalFormInput: {
        item: '',
        val: null,
        type: null,
        type_tax: null
      },
      rulesForm :{
        item: [
          {
            required: true,
            trigger: "change",
            message: 'Item is Required!'
          },
        ],
        val: [
          {
            required: true,
            trigger: "blur",
            validator: checkValue,
          },
        ],
        type:[
          {
            required: true,
            trigger: "change",
          },
        ],
        type_tax:[
          {
            required: false,
            trigger: "change",
          },
        ],
        note:[
          {
            required: false,
          },
        ]
      },
      usageDtl_list: [],
    };
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getDateTimeStandartFormat",
      "getType_tax",
    ]),
    column_process() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      let kolom = [
        {
          title: "#",
          key: "number",
          dataIndex: "number",
          width: this.getscreen ? 20 : 50,
          align: "center",
        },
        {
          title: "No",
          width: this.getscreen ? 100 : 250,
          key: "no",
          scopedSlots: { customRender: "no" },
        },
        {
          title: "Description",
          key: "deskripsi",
          dataIndex: "deskripsi",
          width: this.getscreen ? 180 : 250,
        },

        {
          title: "Value",
          key: "value",
          width: this.getscreen ? 100 : 200,
          scopedSlots: { customRender: "value" },
        },
        {
          title: "Remaining Balance",
          key: "balance",
          width: this.getscreen ? 100 : 200,
          scopedSlots: { customRender: "balance" },
        },
      ];

      if(!this.$route.meta.isFC){
        kolom.push(
          {
            title: "Action",
            key: "centang",
            fixed: "right",
            width: this.getscreen ? 50 : 100,
            align: "center",
            scopedSlots: { customRender: "centang" },
          },
        )
      }

      return kolom;
    },
    column_release() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        {
          title: "#",
          key: "number",
          dataIndex: "number",
          width: this.getscreen ? 20 : 50,
          align: "center",
        },
        {
          title: "No BKK Release",
          width: this.getscreen ? 100 : 250,
          key: "no_trans",
          scopedSlots: { customRender: "no_trans" },
        },
        {
          title: "No Transaksi",
          width: this.getscreen ? 100 : 250,
          key: "no",
          scopedSlots: { customRender: "no" },
        },
        {
          title: "Description",
          key: "deskripsi",
          dataIndex: "deskripsi",
          width: this.getscreen ? 180 : 250,
        },
        {
          title: "Value",
          key: "value",
          width: this.getscreen ? 100 : 200,
          scopedSlots: { customRender: "value" },
        },
        {
          title: "Remaining Balance Release",
          key: "remaining_release",
          width: this.getscreen ? 100 : 200,
          scopedSlots: { customRender: "remaining_release" },
        },
        {
          title: "Update By",
          key: "update_by",
          width: this.getscreen ? 65 : 150,
          align: "center",
          scopedSlots: { customRender: "update_by" },
        },
        {
          title: "Note",
          key: "note",
          dataIndex: "catatan",
          width: this.getscreen ? 180 : 250,
        },
        {
          title: "No BKK",
          key: "no_bkk",
          width: this.getscreen ? 65 : 150,
          align: "left",
          scopedSlots: { customRender: "no_bkk" },
        },
        {
          title: "Status",
          key: "status",
          width: this.getscreen ? 65 : 150,
          align: "center",
          scopedSlots: { customRender: "status" },
        },
        {
          title: "Action",
          key: "action",
          fixed: "right",
          width: this.getscreen ? 50 : 100,
          align: "center",
          scopedSlots: { customRender: "action" },
        },
      ];
      return kolom;
    },
    release_list() {
      let output = this.list_release;

      if (this.search && this.activetab == "release") {
        output = output.filter(
          (obj) =>
            obj.no.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            moment(obj.date_updated)
              .format(this.getDefaultDateFormat)
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0 ||
            obj.tlc_updated.toLowerCase().indexOf(this.search.toLowerCase()) >=
              0 ||obj.no_trans.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            obj.value.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            obj.deskripsi.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            (obj.catatan && obj.catatan.toLowerCase().indexOf(this.search.toLowerCase()) >= 0)
        );
      }
      return output;
    },
    process_list() {
      let output = this.list_process;

      if (this.search && this.activetab == "process") {
        output = output.filter(
          (obj) =>
            obj.no.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            obj.value.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            obj.deskripsi.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }
      return output;
    },
    column_usageDtl() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        {
          title: "#",
          key: "number",
          scopedSlots: { customRender: "number" },
          width: this.getscreen ? 20 : 50,
          align: "center",
        },
        {
          title: "Item Name",
          dataIndex: "item_nm",
          width: this.getscreen ? 100 : 250,
          key: "item_name",
        },
        {
          title: "Value",
          key: "value",
          width: this.getscreen ? 100 : 200,
          scopedSlots: { customRender: "value" },
        },
        {
          title: "Type",
          key: "tax",
          width: this.getscreen ? 100 : 200,
          scopedSlots: { customRender: "tax" },
        },
        {
          title: "Tax Type",
          key: "tax_type",
          width: this.getscreen ? 100 : 200,
          scopedSlots: { customRender: "tax_type" },
        },
        {
          title: "Action",
          key: "centang",
          fixed: "right",
          width: this.getscreen ? 50 : 100,
          align: "center",
          scopedSlots: { customRender: "action" },
        },
      ];
      return kolom;
    },
    subtotal(){
      return _.sumBy(this.usageDtl_list, function (val) {
        return (val.type=='1' || (val.type=='2' && val.type_tax.toLowerCase()=='pph_2529') ? Number(val.value) : 0)
      });
    },
    tax(){
      return _.sumBy(this.usageDtl_list, function (val) {
        return (val.type=='2' ? (val.type_tax.toLowerCase().includes('pph') ? 0 : Number(val.value)) : 0)
      });
    },
    pphValue(){
      return _.sumBy(this.usageDtl_list, function (val) {
        return (val.type=='2' ? (val.type_tax.toLowerCase().includes('pph') ? (Number(val.value)) : 0) : 0)
      });
    },
    remainingBalance(){
      let a = this.nonTaxisExist('add', this.usageDtl_list)
      return this.modalForm.balance_value - (_.sumBy(this.usageDtl_list, function (val) {
        // return (val.type=='2' ? (val.type_tax.toLowerCase().includes('pph') && val.type_tax.toLowerCase()!='pph_2529' ? 0 : (Number(val.value))) : Number(val.value))
        return (val.type=='2' ? ( a ? 0 : Number(val.value)) : Number(val.value))
      }));
    },
    grandtotals(){
    return this.subtotal+this.tax
    },
    isOnlyNonItem(){
      let result = false;
      let itemExist = _.filter(this.usageDtl_list, (e) => e.type && e.type == '1')
      if(this.usageDtl_list.length>0 && itemExist.length==0){
        result = true;
      }
      return result
    },
    onlyViews(){
      if(this.$route.meta && this.$route.meta.onlyView){
        return true
      }
      return false
    }
  },
  mounted() {
    this.$store.dispatch("Fetch_TYPE_TAX");

    if(!this.onlyView)
      this.activetab="release"

    this.fetchData();

    if(this.idrilisedit){
      this.fetchEdit()
    }
  },
  methods: {
    moment,
    async fetchData() {
      if (this.activetab == "release") {
        this.loading.release = true;
      } else {
        this.loading.process = true;
      }
      this.typepage = this.$route.meta.page_type;
      const release = axios({
        method: "get",
        url: this.$serviceUrl + "pi/rilis",
        params: {
          tab: "bkk release",
          jenis: this.typepage,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      }).catch((err) => {
        console.log(err);
      });

      const proses = axios({
        method: "get",
        url: this.$serviceUrl + "pi/rilis",
        params: {
          tab: "need process",
          jenis: this.typepage,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      }).catch((err) => {
        console.log(err);
        this.loading.release = false;
        this.loading.process = false;
      });

      return await new Promise((resolve, reject) => {
        axios
          .all([
            release.catch((err) => {
              console.log(err);
              return null;
            }),
            proses.catch((err) => {
              console.log(err);
              return null;
            }),
          ])
          .then((response) => {
            this.list_release = response[0] ? response[0].data.data : [];
            this.list_process = response[1] ? response[1].data.data : [];
            if (this.list_process.length > 0) {
              for (let index = 0; index < this.list_process.length; index++) {
                let col = [
                  {
                    ...this.list_process[index],
                    key: "a" + (index + 1),
                    number: index + 1,
                    dana_sts: false,
                  },
                ];
                this.list_process[index] = col[0];
              }
            }
            if (this.list_release.length > 0) {
              for (let index = 0; index < this.list_release.length; index++) {
                let col = [
                  {
                    ...this.list_release[index],
                    key: "b" + (index + 1),
                    number: index + 1,
                  },
                ];
                this.list_release[index] = col[0];
              }
            }
            this.loading.release = false;
            this.loading.process = false;
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    async fetchEdit(){
      const edit = axios({
        method: "get",
        url: this.$serviceUrl + "pi/rilis_edit",
        params: {
          id_rilis: this.idrilisedit,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      }).catch((err) => {
        console.log(err);
      });

      return await new Promise((resolve, reject) => {
        axios
          .all([
              edit.catch((err) => {
              console.log(err);
              return null;
            }),
          ])
          .then((response) => {
            if(!response[0]){
              this.displayMessageValue(
                "error-other",
                "Access Denied"
              );
              this.$router.push({
                name: "PIRelease",
                params: {},
              });
            }else{
              let item = {
                id: response[0].data.invoice[0].id_rilis,
                no: response[0].data.invoice[0].kode_anggaran,
                currency: response[0].data.invoice[0].currency,
                sisa: response[0].data.invoice[0].saldo,
                deskripsi: response[0].data.invoice[0].deskripsi,
                catatan: response[0].data.invoice[0].catatan,
                flag: "new"
              }
              this.usageDtl_list = response[0].data.dtl_invoice
              this.handlemodal(item)
            }
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    handleTab(val) {
      this.activetab = val;
      this.search = "";
      if (this.activetab == "release") {
        this.loading.release = true;
      } else {
        this.loading.process = true;
      }
      this.fetchData();
    },
    handleLink(jenis, id_) {
      let manifest = "";
      if (jenis == "pi") {
        manifest = "PiManifest";
      } else if (jenis == "umpp") {
        manifest = "UmppManifest";
      } else if (jenis == "umpd") {
        manifest = "umpd_manifest";
      } else if (jenis == "klaimpd") {
        manifest = "manifestKlaimPd";
      } else if (jenis == "klaimpp") {
        manifest = "manifestKlaimPp";
      }else if (jenis == "klaimdirektur") {
        manifest = "manifestDirectur";
      }else if (jenis == "bkk") {
        manifest = "bkkManifestKeu";
      }
       else {
        manifest = "lapUmppManifest";
      }
      const route = this.$router.resolve({
        name: manifest,
        params: { id: id_ },
      });
      window.open(route.href, "_blank");
    },
    changeActionItem() {
      if(this.modalForm.flag=='new'){
        if (this.usageDtl_list.length == 0) {
          this.displayMessageValue("error-other", "Usage Detail Can't Be Empty!");
        } else if(this.grandtotals < 0) {
          this.displayMessageValue("error-other", "Grand Total Can't be Negatif!");
        } else{
          this.loadingmodalsave = true;

          let formData = new FormData();
          if(this.idrilisedit){
            formData.append("id_rilis", this.modalForm.id);
          } else {
            formData.append("id", this.modalForm.id);
          }
          formData.append("value_rilis", (this.isOnlyNonItem ? this.tax+this.pphValue : this.grandtotals-this.pphValue));
          formData.append("value_total", (this.isOnlyNonItem ? this.tax+this.pphValue  : this.grandtotals));
          formData.append("catatan", this.modalForm.note ? this.modalForm.note : '');

          this.usageDtl_list.forEach((e) => {
            formData.append("item[]", e.item_nm);
            formData.append("value[]", e.value);
            formData.append("type[]", e.type);
            formData.append("type_tax[]", e.type_tax);
          })

          axios({
            method: "post",
            url: this.$serviceUrl + (this.idrilisedit ? "pi/rilis_edit" : "pi/rilis"),
            data: formData,
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "Content-Type": "multipart/form-data",
              "X-API-KEY": this.getAuth.apikey,
            },
          })
          .then((response) => {
            this.handleCloseModal();
            this.displayMessage("success-save");
            Event.$emit("trigfetchnotif", true);
            this.fetchData();
            this.activetab = "release";
            this.loadingmodalsave = false;
          })
          .catch((err) => {
            let responses = Object.assign({}, err.response);
            console.log(responses)
            if(responses.data){
              this.displayMessageValue("error-other", responses.data.message);
            }else{
              this.displayMessageValue("error", responses);
            }
            this.loadingmodalsave = false;
          });
        }
      } else {
        this.$refs.modalForm.validate((valid) => {
        if (!valid) {
          this.displayMessage("form-warning");
          return;
        }
          
        if (this.modalForm.val > this.modalForm.maxval) {
          this.displayMessageValue("error-basic", "Value is grather than remaining balance!");
        }else{
          this.loadingmodalsave = true;
            axios({
              method: "post",
              url: this.$serviceUrl + "bkk_release",
              processData: false,
              data: {
                tlc: this.getAuth.username,
                jenis_transaksi: this.typepage,
                id_transaksi: this.modalForm.id,
                catatan: this.modalForm.note,
                value: this.modalForm.val,
              },
              auth: {
                username: this.getAuth.username,
                password: this.getAuth.password,
              },
              headers: {
                "Content-Type": "application/json",
                "X-API-KEY": this.getAuth.apikey,
              },
            })
            .then((response) => {
              this.handleCloseModal();
              this.displayMessage("success-save");
              Event.$emit("trigfetchnotif", true);
              this.fetchData();
              this.activetab = "release";
              this.loadingmodalsave = false;
            })
            .catch((err) => {
              let responses = Object.assign({}, err.response.data);
              this.displayMessageValue("error", responses);
              this.loadingmodalsave = false;
            });
          }
        });
      }

      if(this.idrilisedit){
        this.$router.push({
          name: "PIRelease",
          params: {},
        });
      }
    },
    handlemodal(item){ 
      if(item.flag=='new'){
        this.processModal = true;
        this.modalForm = {
          flag: item.flag,
          mode: 'create',
          id: item.id,
          no: item.no,
          currency: item.currency,
          balance_value: item.sisa,
          description: item.deskripsi,
          val: item.sisa,
          maxval: Number(item.sisa),
          note: item.catatan,
        };
      } else {
        this.processModalOld = true;
        this.modalForm = {
          flag: item.flag,
          id: item.id,
          no: item.no,
          description: item.deskripsi,
          val: item.sisa,
          maxval: Number(item.value),
          note: null,
        };
      }
    },
    resetfieldModal(){
      this.usageDtl_list = []
      this.modalForm = {
        mode: 'create',
        id: null,
        no: null,
        description: null,
        currency: 'IDR',
        balance_value: 0,
        val: null,
        maxval: 0,
        note: null,
      };
    },
    handleCloseModal(){
      this.resetfieldModal();
      this.processModal = false;
      this.processModalOld = false;
      this.$router.push({
        name: "PIRelease",
        params: {},
      });
    },
    handleOkModal(){
      this.changeActionItem();
    },
    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handleChangeType(val){
      this.modalFormInput.type_tax = null
      if(val.target.value=='2'){
        this.rulesForm.type_tax[0].required = true
      }else{
        this.rulesForm.type_tax[0].required = false
      }
    },
    getlabeltax(val){
      return val ? _.filter(this.getType_tax, (e) => e.value == val)[0].text : ''
    },
    handleAdd(){
      this.$refs.modalForm.validate((valid) => {
        if (!valid) {
          this.displayMessage("form-warning");
          return;
        }

        let existing = _.filter(this.usageDtl_list, (e) => e.item_nm.trim().toLowerCase() == this.modalFormInput.item.trim().toLowerCase())
        let acumulate = this.remainingBalance-(this.modalFormInput.type=='2' && this.modalFormInput.type_tax.includes('pph') ? 0 : this.modalFormInput.val)
        if(existing.legth>0){
          this.displayMessageValue(
              "error-other",
              "Item name is already exist!"
            );
        } else if(acumulate<0){
          this.displayMessageValue(
              "error-other",
              "Remaining alance not enough!"
            );
        }else{
          // if(this.nonTaxisExist('add', this.usageDtl_list) || this.modalFormInput.type_tax=='pph_2529'){
            this.usageDtl_list.push(
              {
                item_nm: this.modalFormInput.item,
                value: this.modalFormInput.val,
                type: this.modalFormInput.type,
                type_tax: this.modalFormInput.type_tax
              }
            )

            this.modalFormInput= {
              item: '',
              val: null,
              type: null,
              type_tax: null
            }
          // }else{
          //   this.displayMessageValue(
          //     "error-other",
          //     "Item Non Tax Must be Present before others!"
          //   );
          // }
        }
      })
    },
    handleEdit(item){
      let index = _.findIndex(this.usageDtl_list, (e) => {return e.item_nm.trim().toLowerCase() == item.item_nm.trim().toLowerCase()})
      this.modalForm.mode = 'edit'
      this.modalForm.indexDataEdit = index
      this.modalFormInput= {
        id: item.item_nm,
        item: item.item_nm,
        val: item.value,
        type: item.type,
        type_tax: item.type_tax
      }
    },
    handleRemove(item){
      // let trigger = false
      // if(this.usageDtl_list.length == 1){
      //   trigger = true
      // } else {
      //   let temp = _.filter(this.usageDtl_list, (e)=> e.type == '1' && e.item_nm != item.item_nm)
      //   if(temp.length > 0){
      //     trigger = true
      //   }else{
      //     trigger = false
      //   }
      // }

      // if(trigger) {
        this.usageDtl_list = _.filter(this.usageDtl_list, (e)=> e.item_nm!=item.item_nm)
      // }else{
      //   this.displayMessageValue(
      //     "error-other",
      //     "Item Non Tax Must be Present before delete others!"
      //   );
      // }
    },
    handleCancel(){
      this.modalFormInput= {
        item: '',
        val: null,
        type: null,
        type_tax: null
      }
      this.modalForm.mode = 'create'
    },
    handleSaveEdit(){
      let existing = _.filter(this.usageDtl_list, (e) => e.item_nm.trim().toLowerCase() == this.modalFormInput.item.trim().toLowerCase())

      let tempadta = this.usageDtl_list[this.modalForm.indexDataEdit]
      let acumulate = this.remainingBalance+(tempadta.type=='2' && tempadta.type_tax.includes('pph') ? 0 : tempadta.value )-(this.modalFormInput.type=='2' && this.modalFormInput.type_tax.includes('pph') ? 0 : this.modalFormInput.val)
      if(existing.legth>0){
          this.displayMessageValue(
              "error-other",
              "Item name is already exist!"
            );
      } else if(acumulate<0){
          this.displayMessageValue(
              "error-other",
              "Remaining alance not enough!"
            );
      }else{
        //if(this.nonTaxisExist('edit', this.usageDtl_list)){
          this.usageDtl_list[this.modalForm.indexDataEdit].item_nm = this.modalFormInput.item
          this.usageDtl_list[this.modalForm.indexDataEdit].value = this.modalFormInput.val
          this.usageDtl_list[this.modalForm.indexDataEdit].type = this.modalFormInput.type
          this.usageDtl_list[this.modalForm.indexDataEdit].type_tax = this.modalFormInput.type_tax

          this.handleCancel()
        // } else {
        //   this.displayMessageValue(
        //     "error-other",
        //     "Item Non Tax Must be Present before others!"
        //   );
        // }
      }
    },
    handleManifest(item){
      this.$router.push({
        name: "ManifestPIRelease",
        params: { id: item.id_rilis },
      });
    },
    nonTaxisExist(mode, val){
      if(mode=='add' && val.length == 0 && this.modalFormInput.type=='1') {
        return true
      } else if (val.length>0){
        let temp = _.filter(val, e => e.type == '1')
        if(temp.length>0){
          return true
        }else{
          return false
        }
      } else {
        return false
      }
    },
  },
};
</script>

<style lang="less" scoped>
.title {
  text-transform: capitalize;
}
.divButtonAdd {
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-end;
}
</style>
